Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    pieLabelColor: tokens.themeInkDefault,
    pieLabelSize: 20,
    pieLabelWeight: 400,
    pieLabelFontFamily: "\"Amazon Ember\", \"Amazon Ember Arabic\", Arial, sans-serif",
    pieDataOpacityDefault: 100,
    pieDataOpacityInactive: 20,
    pieDataScaleDefault: 100,
    pieDataScaleActive: 110,
    pieDataMotionDuration: "150ms",
    pieDataMotionFunction: "ease",
    pieDataBorderWidth: 1,
    pieDataBorderColorDefault: tokens.themeBorderStrong,
    pieDataBorderColorInverse: tokens.themeBorderInverse
  }
};